export const glossaryFaqItems = [
  {
    id: 'pip-vs-pipette',
    q: 'Pip กับ Pipette ต่างกันอย่างไร?',
    a: 'Pip คือหน่วยวัดว่าราคาเคลื่อนไหวไปเท่าไร คู่เงินส่วนใหญ่นับที่ทศนิยมตำแหน่งที่ 4 เช่น EUR/USD 1.0842 ไปเป็น 1.0843 คือ 1 Pip ส่วนคู่เงินสกุล JPY นับที่ตำแหน่งที่ 2 เช่น USD/JPY 148.10 ไปเป็น 148.11 คือ 1 Pip',
    a2: 'Pipette หรือ Point คือทศนิยมตำแหน่งถัดไป ซึ่งมีค่าเพียง 0.1 Pip ใช้แสดงความละเอียดของราคาบนแพลตฟอร์มรุ่นใหม่ ถ้าโบรกเกอร์แจ้งสเปรดหรือระยะ Stop Loss เป็น Point ต้องหาร 10 ก่อนจึงจะได้ค่าเป็น Pip',
    termIds: ['pip', 'pipette'],
  },
  {
    id: 'spread-cost',
    q: 'Spread คือต้นทุนแบบไหน และคิดออกมาเป็นเงินได้อย่างไร?',
    a: 'Spread คือผลต่างระหว่างราคา Ask กับ Bid และเป็นต้นทุนที่ถูกหักทันทีตอนเปิดออเดอร์ เช่น Ask 1.0850 กับ Bid 1.0848 เท่ากับ 2 Pip ถ้าเทรด 1 Standard Lot บน EUR/USD ซึ่งมูลค่า 1 Pip ประมาณ 10 ดอลลาร์ ต้นทุนเปิดไม้ครั้งนี้จะอยู่ที่ราว 20 ดอลลาร์',
    a2: 'นั่นหมายความว่าราคาต้องเคลื่อนไปอย่างน้อย 2 Pip ถึงจะเท่าทุน ช่วงที่สภาพคล่องต่ำ เช่น ปลายสัปดาห์หรือตอนมีข่าวสำคัญ Spread มักกว้างขึ้น ต้นทุนต่อไม้จึงสูงกว่าเวลาตลาดปกติ',
    termIds: ['spread', 'bid', 'ask'],
  },
  {
    id: 'leverage-risk',
    q: 'Leverage สูงทำให้เสี่ยงมากขึ้นจริงไหม?',
    a: 'Leverage ไม่ได้ทำให้ขาดทุนต่อ Pip มากขึ้น แต่ทำให้คุมสถานะใหญ่ได้ด้วยเงินประกันที่น้อยลง ความเสี่ยงจริงขึ้นอยู่กับขนาด Lot และระยะ Stop Loss มากกว่า ถ้าเปิด 1 Lot เท่ากัน การขาดทุนต่อ Pip จะเท่ากันไม่ว่าจะใช้ 1:100 หรือ 1:500',
    a2: 'สิ่งที่ต่างคือเงินที่ถูกกันไว้เป็น Margin เช่น 1:100 ใช้ 1% ของมูลค่าสัญญา ส่วน 1:500 ใช้เพียง 0.2% ยิ่งกันเงินไว้น้อย พื้นที่รับแรงกระแทกของพอร์ตก็ยิ่งน้อย และมีโอกาสถึงจุด Margin Call เร็วขึ้นหากไม่วางแผนขนาดออเดอร์ให้ดี',
    termIds: ['leverage', 'margin'],
  },
  {
    id: 'position-size',
    q: 'คำนวณขนาด Lot จากความเสี่ยงที่รับได้อย่างไร?',
    a: 'ใช้สูตร เงินที่ยอมเสีย หารด้วย (ระยะ Stop Loss เป็น Pip คูณมูลค่าต่อ Pip) เช่น พอร์ต 1,000 ดอลลาร์ รับความเสี่ยง 1% เท่ากับ 10 ดอลลาร์ ตั้ง Stop Loss 20 Pip และเทรด EUR/USD ที่มูลค่า 1 Pip = 10 ดอลลาร์ต่อ 1 Lot จะได้ 10 หาร (20 คูณ 10) = 0.05 Lot',
    a2: 'ผลคือถ้าถูก Stop Loss เต็มระยะ จะเสียราว 10 ดอลลาร์หรือ 1% ของพอร์ตพอดี และเมื่อทำแบบนี้ทุกไม้ ความเสี่ยงต่อออเดอร์จะเท่ากันสม่ำเสมอ ไม่ว่าเงินในพอร์ตจะโตขึ้นหรือลดลง',
    termIds: ['position-sizing', 'lot', 'risk-per-trade'],
  },
  {
    id: 'stop-loss-vs-stop-out',
    q: 'Stop Loss กับ Stop Out ต่างกันตรงไหน?',
    a: 'Stop Loss คือคำสั่งที่เราเป็นคนตั้งเอง เพื่อปิดออเดอร์เมื่อราคาเดินสวนถึงระดับที่กำหนด เป็นเครื่องมือจำกัดความเสียหายต่อไม้ ส่วน Stop Out คือการที่ระบบของโบรกเกอร์ปิดสถานะให้อัตโนมัติเมื่อ Margin Level ของพอร์ตลดต่ำกว่าเกณฑ์ที่กำหนด หลังถูกเรียก Margin Call แล้ว',
    a2: 'เกณฑ์ Stop Out แตกต่างกันในแต่ละโบรกเกอร์ เช่น 50% หรือ 20% การตั้ง Stop Loss ไว้ล่วงหน้าจึงช่วยให้เราออกตามแผนก่อนที่พอร์ตจะถูกบังคับปิดในราคาที่เราไม่ได้เลือก',
    termIds: ['stop-loss', 'margin-call'],
  },
  {
    id: 'margin-level',
    q: 'Margin, Free Margin และ Margin Level ต่างกันอย่างไร?',
    a: 'Margin คือเงินที่ถูกกันไว้เพื่อค้ำประกันสถานะที่เปิดอยู่ ส่วน Free Margin คือเงินที่เหลือและยังใช้เปิดออเดอร์ใหม่ได้ ถ้าพอร์ตมี 1,000 ดอลลาร์ และใช้ Margin ไป 200 ดอลลาร์ จะเหลือ Free Margin 800 ดอลลาร์',
    a2: 'Margin Level คือสัดส่วน Equity ต่อ Margin ที่ใช้ คิดเป็นเปอร์เซ็นต์ ใช้บอกว่าพอร์ตยังมีกันชนมากแค่ไหน ยิ่งตัวเลขต่ำ ยิ่งใกล้จุดที่โบรกเกอร์จะเรียก Margin Call หรือปิดสถานะอัตโนมัติ',
    termIds: ['margin', 'margin-call', 'leverage'],
  },
  {
    id: 'risk-reward-ratio',
    q: 'Risk / Reward 1:2 คุ้มจริงไหม และควรตั้งไว้เท่าไร?',
    a: 'Risk / Reward 1:2 หมายถึงยอมเสี่ยง 1 หน่วยเพื่อโอกาสทำกำไร 2 หน่วย เช่น Stop Loss 25 Pip กับ Take Profit 50 Pip อัตราส่วนนี้บอกว่าแต่ละไม้คุ้มแค่ไหน แต่ไม่ได้บอกว่าจะชนะบ่อยแค่ไหน',
    a2: 'ที่ 1:2 จุดคุ้มทุนอยู่ที่อัตราชนะประมาณ 33% หรือชนะเพียง 1 ใน 3 ของจำนวนไม้ก็ยังไม่ขาดทุน มือใหม่จึงมักเริ่มจาก 1:2 ขึ้นไป และเลือกเป้าหมายที่ราคาไปถึงได้จริง มากกว่าตั้งไกลจนแทบไม่เคยถึง',
    termIds: ['risk-reward', 'stop-loss', 'take-profit'],
  },
];